import BaseUseCase from "../../../base_use_case.js";

class WebIdFilesUseCase extends BaseUseCase {

  execute(identifier) {
    return this.httpClient({
      ...this.requestConfig(),
      method: "get",
      url: `/api/v1/admin/users/users/${identifier}/webid_files`,
    });
  }
}

const instance = new WebIdFilesUseCase();
export default instance;